import { Transform as TransformCore } from 'class-transformer';

export const Transform = TransformCore;
